define('common/ko/extension/wrap',['underscore', 'knockout'], function (_, ko) {
    ko.extenders.wrap = function(wrappedTarget, source) {
        if(ko.isObservable(source)) {
            source.subscribe(function(value) {
                wrappedTarget(value);
            });
            wrappedTarget(source.peek());
        } else
            wrappedTarget(source);

        wrappedTarget.revert = function() {
            wrappedTarget(source());
        };

        wrappedTarget.isDirty = ko.pureComputed(function(){
            return source() !== wrappedTarget();
        });

        wrappedTarget.save = function() {
            if(!ko.isObservable(source)) throw 'You cannot commit to a non-observable';
            var wrappedTargetValue = wrappedTarget();
            if(wrappedTarget.isDirty()) source(wrappedTargetValue);
        };

        return wrappedTarget;
    };
});

